<template>
  <div class="nz-modal" @click.self="requestClose(null)">
    <div
      class="nz-modal-content"
      :class="sizeClass"
      :key="sizeClass + '-' + title"
      @click.stop
    >
      <!-- HEADER -->
      <div class="nz-modal-header">
        {{ title }}
        <span v-if="record">
          - {{ record.label }}
          <span class="nz-modal-id"> - id {{ record.id }}</span>
        </span>

        <span class="icon-cross" @click.stop="requestClose(null)"></span>
      </div>

      <!-- BODY -->
      <div class="nz-modal-body">
        <!--
          We inject the editor into a wrapper so we can
          inspect or locate the child instance safely.
        -->
        <div class="modal-body-wrapper" ref="body">
          <slot />
        </div>
      </div>

      <!-- FOOTER -->
      <div class="nz-modal-footer">
        <slot name="footer" />
      </div>

    </div>
  </div>
</template>

<script>

import { onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import ModalManager from "@/components/modal/ModalManager";

const instance = getCurrentInstance();

onMounted(() => {
  ModalManager.setChildInstance(instance);
});

onBeforeUnmount(() => {
  ModalManager.clearChildInstance(instance);
});

export default {
  props: {
    title:  { type: String, required: true },
    record: { type: Object, default: null },
    size:   { type: String, default: "md" },

    /**
     * A callback provided via ModalManager.open()
     * detectValidation(instance) → bool
     *
     * Called ONLY when the editor closes without an explicit payload.
     */
    detectValidation: { type: Function, default: null }
  },

  computed: {
    sizeClass() {
      return `modal-size-${this.size}`;
    }
  },

  methods: {
    /**
     * Scan the modal body to find the FIRST Vue component instance.
     * Works with Vue 3 by reading the internal vnode instance.
     */
    getChildInstance() {
      const root = this.$refs.body;
      if (!root) return null;

      // look at all direct children inside wrapper
      const children = root.children;
      for (const el of children) {
        const inst = el.__vueParentComponent?.proxy;
        if (inst) return inst;
      }
      return null;
    },

    /**
     * requestClose(payload)
     *
     * payload === true/false → editor explicitly decided
     * payload === null       → modal must infer using detectValidation
     */
    requestClose(payload) {

      // Editor explicitly closed (save/cancel)
      if (payload !== null) {
        this.$emit("close", payload);
        return;
      }

      // Modal must determine the result (header close, overlay close)
      if (typeof this.detectValidation === "function") {
        const inst = this.getChildInstance();
        try {
          const detected = !!this.detectValidation(inst);
          this.$emit("close", detected);
        } catch (err) {
          console.warn("Modal detectValidation failed:", err);
          this.$emit("close", null);
        }
        return;
      }

      // No rules → close with null
      this.$emit("close", null);
    }
  }
};
</script>
